import { Switch } from '@heroui/react';
import { FC } from 'react';
import { MapBoxGlobeMapStyles } from '../../../../utils/mapHelpers';
import { FiSun, FiMoon } from 'react-icons/fi';

interface IMapStyleChangerProps {
	changeMapStyle: (event: any) => void;
	mapStyle: string;
	isEnabled?: boolean;
}
const MapStyleChanger: FC<IMapStyleChangerProps> = ({ ...props }) => {
	return (
		<div className="absolute z-10 opacity-85 ml-2" style={{ bottom: 8, right: 44 }}>
			<Switch
				isDisabled={!props.isEnabled}
				classNames={{
					wrapper: 'rounded',
					thumb: 'rounded',
				}}
				//size="sm"
				onChange={props.changeMapStyle}
				color="default"
				startContent={<FiMoon />}
				endContent={<FiSun />}
				title={
					props.mapStyle === MapBoxGlobeMapStyles.Msi_Day || props.mapStyle === MapBoxGlobeMapStyles.Msi_Day_Satellite
						? 'Dark Map'
						: 'Light Map'
				}
				isSelected={props.mapStyle === MapBoxGlobeMapStyles.Msi_Day || props.mapStyle === MapBoxGlobeMapStyles.Msi_Day_Satellite}
			/>
		</div>
	);
};

export default MapStyleChanger;
